import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getAppByQreIdSurveyOptions } from '../../generated-evs/@tanstack/react-query.gen';
import useQreId from '../../../hooks/useQreId';

export const useSurveyData = () => {
  const { qreId, isValid } = useQreId();

  const { data, isLoading, error, isError } = useQuery({
    ...getAppByQreIdSurveyOptions({ path: { qreId } }),
    enabled: isValid,
  });

  return useMemo(
    () => ({
      data,
      isLoading,
      error,
      isError,
    }),
    [data, isLoading, error, isError]
  );
};
